import { Provider } from '@angular/core';
import { AmendmentHistorySource } from './amendment-history-source';
import { ContractAmendmentsHistory } from './contract-amendments-history';
import { ContractCreationHistorySource } from './contract-creation-history-source';
import { CONTRACT_HISTORY_SOURCES } from './history-entry.model';
import { NotificationHistorySource } from './notification-history-source';
import { SalaryRevaluationHistorySource } from './salary-revaluation-history-source';
import { SignatureHistorySource } from './signature-history-source';
import { ValidationHistorySource } from './validation-history-source';

/**
 * Les sources du fil d'historique d'un contrat. Leur ordre est celui des filtres par origine ;
 * une origine nouvelle s'ajoute ici, par sa source. Les avenants, lus une fois, sont partagés entre
 * les sources qui y rattachent leurs entrées.
 */
export function provideContractHistorySources(): Provider[] {
  return [
    ContractAmendmentsHistory,
    { provide: CONTRACT_HISTORY_SOURCES, useClass: ValidationHistorySource, multi: true },
    { provide: CONTRACT_HISTORY_SOURCES, useClass: SignatureHistorySource, multi: true },
    { provide: CONTRACT_HISTORY_SOURCES, useClass: AmendmentHistorySource, multi: true },
    { provide: CONTRACT_HISTORY_SOURCES, useClass: SalaryRevaluationHistorySource, multi: true },
    { provide: CONTRACT_HISTORY_SOURCES, useClass: NotificationHistorySource, multi: true },
    { provide: CONTRACT_HISTORY_SOURCES, useClass: ContractCreationHistorySource, multi: true },
  ];
}
